export default [
  '<header class="container-fluid">',
  '  <nav class="navbar navbar-light bg-transparent border-bottom">',
  '    <div class="container-fluid">',
  '     <a class="navbar-brand" href="#">',
  '       <img src="https://res.cloudinary.com/missada/image/upload/v1645340728/Tf.js%20Playground/tfjs_playground_smaller_alt_3.png" alt="" width="30" height="30" class="d-inline-block align-text-top">',
  '       Image Classification Playground',
  '       <span class="sub-heading">',
  '         Powered by TF.js',
  '       </span>',
  '     </a>',
  '    </div>',
  '  </nav>',
  '</header>',
  '<main>',
  '  <div class="container pt-3">',
  '    <h1>TensorFlow.js Mobilenet Playground.</h1>',
  '    <p>',
  '      This playground uses the TensorFlow.js Mobilenet model to extract the possible classes to which an image belongs.',
  '    </p>',
  '    <div class="my-3">',
  '      <img src="" class="img-fluid mb-3" id="sampleImage" crossorigin="anonymous" />',
  '    </div>',
  '    <form id="mobilenetModelForm">',
  '      <div class="mb-3">',
  '        <label for="imageUrl" class="form-label">Enter an image url to change the image used</label>',
  '        <div class="input-group">',
  '          <input type="text" class="form-control" placeholder="URL to image" aria-label="Image URL username with two button addons" id="imageUrl" name="image_url" required />',
  '          <button class="btn btn-outline-warning image-url-buttons" type="button" id="revert">Revert</button>',
  '          <button class="btn btn-warning image-url-buttons" type="submit" id="submit">Use Own Image</button>',
  '        </div>',
  '      </div>',
  '    </form>',
  '    <div class="card my-5">',
  '      <div class="card-body">',
  '        <div id="error"></div>',
  '        <div id="classificationResultsContainer">',
  '          <h2>Classification Results From Model</h2>',
  '          <ul id="classificationResults"></ul>',
  '        </div>',
  '      </div>',
  '    </div>',
  '  </div>',
  '</main>',
  '',
  '',
  '',
].join('\n');
